// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_40p","cls2":"LettersModal-cls2_HBq LettersModal-cls1_40p"};